exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".avatar--background {\n  background-size: 64px;\n  background-position: center;\n  vertical-align: middle; }\n\n.sidebar-header {\n  background-color: #54cf96; }\n\n.sidebar .menu:not(.menu-bordery) > .menu-item.active > .menu-link {\n  background-color: #926dde; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /builds/ulalachef/ulalachef-dashboard/src/app/components/home/home.component.scss
// module id = ../../../../../src/app/components/home/home.component.scss
// module chunks = main